/**
 *  @prop  --cbp-accordion-item-color: var(--cbp-color-text-darker);
 *  @prop  --cbp-accordion-item-color-fill: var(--cbp-color-gray-cool-10);
 *  @prop  --cbp-accordion-item-border-width: var(--cbp-border-width-xs);
 *  @prop  --cbp-accordion-item-border-style: solid;
 *  @prop  --cbp-accordion-item-color-hover: var(--cbp-color-text-darker);
 *  @prop  --cbp-accordion-item-color-fill-hover: var(--cbp-color-interactive-secondary-light);
 *  @prop  --cbp-accordion-item-color-open-hover: var(--cbp-color-text-lightest);
 *  @prop  --cbp-accordion-item-color-fill-open-hover: var(--cbp-color-interactive-secondary-darker);
 *  @prop  --cbp-accordion-item-color-focus: var(--cbp-color-text-lightest);
 *  @prop --cbp-accordion-item-color-fill-focus: var(--cbp-color-interactive-focus-dark);
 *  @prop  --cbp-accordion-item-color-outline-focus: var(--cbp-color-white);
 *  @prop  --cbp-accordion-item-color-active: var(--cbp-color-text-lightest);
 *  @prop  --cbp-accordion-item-color-fill-active: var(--cbp-color-interactive-active-dark);
 *  @prop  --cbp-accordion-item-border-radius: var(--cbp-border-radius-sharp, 0);
 *  @prop  --cbp-accordion-item-control-font-size: var(--cbp-font-size-heading-sm);
 *  @prop  --cbp-accordion-item-control-font-weight: var(--cbp-font-weight-semibold);
 *  @prop  --cbp-accordion-item-control-gap: var(--cbp-space-3x);
 *  @prop  --cbp-accordion-item-control-padding: var(--cbp-space-3x);
 *  @prop  --cbp-accordion-item-control-direction: row;
 *  @prop  --cbp-accordion-item-color-content: var(--cbp-color-text-darkest);
 *  @prop  --cbp-accordion-item-color-fill-content: var(--cbp-color-white);
 *  @prop  --cbp-accordion-item-content-font-size: var(--cbp-font-size-md);
 *  @prop  --cbp-accordion-item-content-font-family: inherit;
 *  @prop  --cbp-accordion-item-content-font-weight: var(--cbp-font-weight-regular);
 *  @prop  --cbp-accordion-item-content-padding: var(--cbp-space-3x);
 */
:root {
  --cbp-accordion-item-color: var(--cbp-color-text-darker);
  --cbp-accordion-item-color-fill: var(--cbp-color-gray-cool-10);
  --cbp-accordion-item-color-open: var(--cbp-color-text-lighter);
  --cbp-accordion-item-color-fill-open: var(--cbp-color-gray-cool-60);

  --cbp-accordion-item-color-hover: var(--cbp-color-text-darker);
  --cbp-accordion-item-color-fill-hover: var(--cbp-color-interactive-secondary-light);
  --cbp-accordion-item-color-open-hover: var(--cbp-color-text-lightest);
  --cbp-accordion-item-color-fill-open-hover: var(--cbp-color-interactive-secondary-darker);

  --cbp-accordion-item-color-focus: var(--cbp-color-text-lightest);
  --cbp-accordion-item-color-fill-focus: var(--cbp-color-interactive-focus-dark);
  --cbp-accordion-item-color-outline-focus: var(--cbp-color-white);

  --cbp-accordion-item-color-active: var(--cbp-color-text-lightest);
  --cbp-accordion-item-color-fill-active: var(--cbp-color-interactive-active-dark);

  --cbp-accordion-item-border-width: var(--cbp-border-width-xs);
  --cbp-accordion-item-border-style: solid;
  --cbp-accordion-item-border-radius: var(--cbp-border-radius-sharp, 0);

  --cbp-accordion-item-control-font-size: var(--cbp-font-size-heading-sm);
  --cbp-accordion-item-control-font-weight: var(--cbp-font-weight-semibold);

  --cbp-accordion-item-control-gap: var(--cbp-space-3x);
  --cbp-accordion-item-control-padding: var(--cbp-space-3x);
  --cbp-accordion-item-control-direction: row;

  --cbp-accordion-item-color-content: var(--cbp-color-text-darkest);
  --cbp-accordion-item-color-fill-content: var(--cbp-color-white);
  --cbp-accordion-item-content-font-size: var(--cbp-font-size-md);
  --cbp-accordion-item-content-font-family: inherit;
  --cbp-accordion-item-content-font-weight: var(--cbp-font-weight-regular);
  --cbp-accordion-item-content-padding: var(--cbp-space-3x);

  --cbp-accordion-item-heading-gap: var(--cbp-space-2x);
}

cbp-accordion-item {
  display: flex;
  flex-direction: column;

  &[open] {
    --cbp-accordion-item-color: var(--cbp-accordion-item-color-open);
    --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-open);

    .cbp-accordion-item--control {
      --cbp-accordion-rotate-icon: rotate(270deg);
      --cbp-accordion-toggle: expandTo 500ms;

      &:hover:not(:focus-within):not(:active) {
        --cbp-accordion-item-color: var(--cbp-accordion-item-color-open-hover);
        --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-open-hover);

        + .cbp-accordion-item--content {
          --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-open-hover);
        }
      }
    }
  }

  .cbp-accordion-item--control {
    display: flex;
    flex-direction: var(--cbp-accordion-item-control-direction, row);
    align-items: center;
    gap: var(--cbp-accordion-item-control-gap);
    min-height: var(--cbp-space-13x);
    color: var(--cbp-accordion-item-color);
    --cbp-button-color: var(--cbp-accordion-item-color);
    background-color: var(--cbp-accordion-item-color-fill);
    font-size: var(--cbp-accordion-item-control-font-size);
    font-weight: var(--cbp-accordion-item-control-font-weight);
    padding: var(--cbp-accordion-item-control-padding);
    outline-style: solid;
    outline-color: var(--cbp-accordion-item-color-outline-focus);
    outline-width: 0;
    outline-offset: calc(-1 * var(--cbp-space-1x));
    cursor: pointer;

    .cbp-accordion-item--heading {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;

      :first-child {
        flex-grow: 1;
      }

      [slot="cbp-accordion-item-label"] {
        display: flex;
        align-items: center;
        gap: var(--cbp-accordion-item-heading-gap);
      }

    }

    cbp-typography,
    cbp-typography > * {
      color: var(--cbp-accordion-item-color);
    }

    &:hover {
      --cbp-accordion-item-color: var(--cbp-accordion-item-color-hover);
      --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-hover);
    }

    &:focus-within {
      --cbp-accordion-item-color: var(--cbp-accordion-item-color-focus);
      --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-focus);
      outline-width: var(--cbp-border-size-md);

      // button
      .cbp-accordion-item--toggle {
        --cbp-button-color: var(--cbp-accordion-item-color-focus) !important;
      }

      + .cbp-accordion-item--content {
        --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-focus);
      }
    }

    &:active {
      --cbp-accordion-item-color: var(--cbp-accordion-item-color-active);
      --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-active);

      // button
      .cbp-accordion-item--toggle {
        --cbp-button-color: var(--cbp-accordion-item-color-active) !important;
      }

      + .cbp-accordion-item--content {
        --cbp-accordion-item-color-fill: var(--cbp-accordion-item-color-fill-active);
      }
    }

    .cbp-accordion-item--toggle {
      --cbp-button-padding: 0;
      --cbp-button-border-width: 0;
      --cbp-button-focus-outline-width: 0;

      // make sure the button is following the accordion item (control) color
      --cbp-button-color: var(--cbp-accordion-item-color) !important;
      --cbp-button-color-hover: var(--cbp-accordion-item-color) !important;
      --cbp-button-color-focus: var(--cbp-accordion-item-color) !important;
      --cbp-button-color-active: var(--cbp-accordion-item-color) !important;
    
      --cbp-button-color-bg: transparent !important;
      --cbp-button-color-bg-hover: transparent !important;
      --cbp-button-color-bg-focus: transparent !important;
      --cbp-button-color-bg-active: transparent !important;

      cbp-icon svg {
        transition: transform 150ms;
        transform: var(--cbp-accordion-rotate-icon);
      }
    }
  }

  .cbp-accordion-item--content {
    color: var(--cbp-accordion-item-color-content);
    background-color: var(--cbp-accordion-item-color-fill-content);
    padding: var(--cbp-space-4x) var(--cbp-space-3x);
    border-width: var(--cbp-border-size-xl);
    border-style: var(--cbp-accordion-item-border-style);
    border-color: var(--cbp-accordion-item-color-fill);
    border-top: 0;

    animation: var(--cbp-accordion-toggle);
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 10);
    animation-iteration-count: revert;
    animation-fill-mode: forwards;
    overflow: hidden;
  }

  &:not([open]) {
    --cbp-accordion-rotate-icon: rotate(90deg);
  }

  &:not([open]) .cbp-accordion-item--content {
    display: none;
  }

  &[color=danger],
  &[color=danger][open] {
    --cbp-accordion-item-color: var(--cbp-color-text-lightest);
    --cbp-accordion-item-color-fill: var(--cbp-color-danger-base);

    .cbp-accordion-item--control{
      &:hover:not(:focus-within):not(:active) {
        --cbp-accordion-item-color: var(--cbp-color-text-lightest);
        --cbp-accordion-item-color-fill: var(--cbp-color-danger-dark);

        + .cbp-accordion-item--content {
          --cbp-accordion-item-color-fill: var(--cbp-color-danger-dark);
        }
      }
      cbp-typography,
      cbp-typography > * {
        --cbp-accordion-item-color: var(--cbp-color-white);
      }
    }
  }
}


/* 
 * Dark Mode - display dark design based on mode or context
 */
 [data-cbp-theme='light'] cbp-accordion[context*='dark'],
 [data-cbp-theme='dark'] cbp-accordion:not([context='dark-inverts']):not([context='light-always']) {

   --cbp-accordion-item-color: var(--cbp-color-text-lightest);
   --cbp-accordion-item-color-fill: var(--cbp-color-gray-cool-50);
   --cbp-accordion-item-color-open: var(--cbp-color-text-lightest);
   --cbp-accordion-item-color-fill-open: var(--cbp-color-gray-cool-60);
 
   --cbp-accordion-item-color-hover: var(--cbp-color-text-darkest);
   --cbp-accordion-item-color-fill-hover: var(--cbp-color-interactive-secondary-lighter);
   --cbp-accordion-item-color-open-hover: var(--cbp-color-text-darkest);
   --cbp-accordion-item-color-fill-open-hover: var(--cbp-color-interactive-secondary-light);
 
   --cbp-accordion-item-color-focus: var(--cbp-color-text-darkest);
   --cbp-accordion-item-color-fill-focus: var(--cbp-color-interactive-focus-light);
   --cbp-accordion-item-color-outline-focus: var(--cbp-color-black);
 
   --cbp-accordion-item-color-active: var(--cbp-color-text-darkest);
   --cbp-accordion-item-color-fill-active: var(--cbp-color-interactive-active-light);

   --cbp-accordion-item-color-content: var(--cbp-color-text-lightest);
   --cbp-accordion-item-color-fill-content: var(--cbp-color-gray-cool-90);

  cbp-accordion-item {
    &[color=danger],
    &[color=danger][open] {
      --cbp-accordion-item-color: var(--cbp-color-text-darkest);
      --cbp-accordion-item-color-fill: var(--cbp-color-danger-light);

      .cbp-accordion-item--control:hover:not(:focus-within):not(:active) {
        --cbp-accordion-item-color: var(--cbp-color-text-darkest);
        --cbp-accordion-item-color-fill: var(--cbp-color-danger-lighter);

        + .cbp-accordion-item--content {
          --cbp-accordion-item-color-fill: var(--cbp-color-danger-lighter);
        }
      }
    }
  }
 }
 

@keyframes expandTo {
  from {
    max-height: 0px;
  }
  to {
    max-height: 5000px;
  }
}
